/* @sravni/react-design-system version 0.2.71 */
var getCurrentStep = function (step, currentValue) {
    if (typeof step === 'number') {
        return step;
    }
    if (Array.isArray(step)) {
        for (var index = step.length - 1; index >= 0; index--) {
            var fromValueKey = step[index].from;
            if (currentValue >= fromValueKey) {
                return step[index].step;
            }
        }
    }
    return 1;
};

export { getCurrentStep };
//# sourceMappingURL=getCurrentStep.js.map
